import createGetFormSyncErrors from './selectors/getFormSyncErrors';
import plain from './structure/plain';
export default createGetFormSyncErrors(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/getFormSyncErrors.js
// module id = 1040
// module chunks = 0